import * as Yup from 'yup';

const RULES = {
  required: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email address').required('Required'),
  accept: Yup.boolean().oneOf(
    [true],
    'The terms and conditions must be accepted'
  ),
};

export default RULES;
